import { FC } from "react";

import TiledText from "@/components/BentoList/TiledText";
import { BentoTextElement } from "@/types";

const TiledBlockH1: FC<{ items: BentoTextElement[] }> = ({ items }) => {
  return (
    <div className="grid grid-cols-2 gap-xs h-full">
      {items.map((item, index) => (
        <TiledText slideIndex={index} key={item.id} entry={item} />
      ))}
    </div>
  );
};
export default TiledBlockH1;
